import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { 
  callInfoNotification//, 
  //callSuccessNotification 
} from '@components/Notification';

import { Row, Col } from 'reactstrap';

import { Tooltip } from '../../components/Tippy/index';
import Spinner from '../../components/LoadingStyles/Spinner';
import initService from '../../services/requests/init.service';
import { brandList, standardList, countryList } from '../../app.values';
import './styles.scss';
import TABS from '../../App/tabs';
import { BRAND, APP_STATES } from '@config';
import { APP_TOOLTIPS, loadTooltipss } from '../../texts/tooltips';
import { APP_TEXTS, loadTranslations } from '../../texts/texts';

import Accordion from '../../components/Accordion';
import AccordionItem from '../../components/Accordion/components/AccordionItem';

import UnitsForm from '@components/UnitsForm';
import Input from '@components/Input';
import { mergeDeep } from '@services/helper.service';
//import Input from '@components/Input';

export default class Options extends Component {

  static propTypes = {
    setLocalization: PropTypes.func.isRequired
  };

  countries = [];
  standards = [];
  profiles = [];
  cssEmpty = 'form-control GeneralSettings__select--disabled';
  cssSelected = 'form-control GeneralSettings__select';

  constructor(props) {
    super(props);

    this.state = {
      isPending: true,
      isInitSuccessShown: false,
      'CountryKey': (BRAND === brandList.Sea ? countryList["South East Asia"] : (initService.getBrowserCountry() || '')).toString(),
      'DesignStandard': '',
      'LanguageKey': initService.getBrowserLanguage() || 0,
      'AvailableProfileTypes': '',
      'Brand': BRAND,
      status: null,
      userProfile: {
        companyName: '',
        userName: '',
        phoneNumber: '',
        emailAddress: '',
        websiteAddress: ''
      },
      projectName: 'your-project',
      // extendTimeout: false,
      languages: []
    };
    this.accordionRef = null;
    this.formRef = null;

    this.getCountries();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.appStatus === APP_STATES.NOT_INITIALIZED)
      props.hide3DDimensions();
    // VladP: update internal state when switching to options tab (user can now load a project and settings may be different)
    if (props.appStatus === APP_STATES.LOADING_NEW_STATE || 
      (props.appStatus === APP_STATES.REVIEW_OPTIONS && state.status !== APP_STATES.REVIEW_OPTIONS)) {
      state.CountryKey = props.localization.country;
      state.DesignStandard = props.localization.designStandard;
      state.LanguageKey = props.localization.language;
      state.AvailableProfileTypes = props.localization.profileType;
      state.userProfile = props.userProfile;
      state.projectName = props.projectName;
      // state.extendTimeout = props.extendTimeout || false;
    } 
    if (props.userProfile.needsUpdate) { // initialization
      state.userProfile = {
        companyName: props.userProfile.companyName,
        userName: props.userProfile.userName,
        phoneNumber: props.userProfile.phoneNumber,
        emailAddress: props.userProfile.emailAddress,
        websiteAddress: props.userProfile.websiteAddress
      };
      props.setUserProfile({ needsUpdate: false });
    }
    if (props.appStatus !== state.status)
      state.status = props.appStatus;

    return state;
  }

  componentDidUpdate(prevProps, prevState) {
    // VladP: update the list of standards/profiles when switching to options tab
    if (this.props.appStatus === APP_STATES.REVIEW_OPTIONS && prevProps.appStatus !== APP_STATES.REVIEW_OPTIONS) {
      Promise.all([
        initService.getStandards(this.props.localization.country),
        initService.getProfiles(this.props.localization.country),
        initService.getLanguages(this.props.localization.country)
      ])
        .then(([standards, profiles, languages]) => {
          this.standards = standards;
          this.profiles = profiles;
          this.setState({ languages: languages });
          this.forceUpdate();
        });
    }
    else if (prevProps.appStatus === APP_STATES.REVIEW_OPTIONS && this.props.appStatus !== APP_STATES.REVIEW_OPTIONS) {
      this.props.setLanguage(this.state.LanguageKey);
      this.props.show3DDimensions();
    }
  }

  render() {
    // var string1 = APP_TEXTS.COUNTRY.Content;
    // var string2 = APP_TEXTS.DESIGN_STANDARDS.Content;

    return (
      <Row>
        <Col sm="12">
          <Accordion 
            className="application__accordion" 
            appStatus={this.props.appStatus} 
            activeItem="country-options"
            onItemClick={this.handleAccordionClick.bind(this)}
            onRef={(ref) => this.accordionRef = ref}
          >
            <AccordionItem
              id="country-options"
              title={APP_TEXTS.MENU_OPTIONS_COUNTRY_DESIGN_STANDARD.Content +
                ' / ' + APP_TEXTS.MENU_OPTIONS_LANGUAGE.Content}>

              {this.state.isPending && <Spinner />}
              <div className="calculation base-plate">{/*  used to keep the select controls the same size */}
                <section className="list-type">
                  <Tooltip content={APP_TOOLTIPS.COUNTRY.Content}>
                    <div
                      className="d-flex GeneralSettings__select-holder type_2 mt-2">
                      <span>{APP_TEXTS.COUNTRY.Content}</span>
                      <select className={this.state.CountryKey !== '' ? this.cssSelected : this.cssEmpty}
                        name="CountryKey"
                        value={this.state.CountryKey || ""}
                        onChange={(e) => {
                          this.props.forceRevalidation();
                          this.handleCountry(e);
                        }}
                      >
                        <option value="" disabled>{APP_TEXTS.OPTIONS_SELECT_COUNTRY.Content}</option>
                        {this.countries && this.countries.length && this.countries.map(n => (
                          <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
                        ))}
                      </select>
                    </div>
                  </Tooltip>

                  <Tooltip content={APP_TOOLTIPS.DESIGN_STANDARD.Content}>
                    <div className="d-flex GeneralSettings__select-holder type_2">
                      <span>{APP_TEXTS.DESIGN_STANDARDS.Content}</span>
                      <select className={this.state.DesignStandard.length ? this.cssSelected : this.cssEmpty}
                        name="DesignStandard"
                        id="DesignStandard"
                        disabled={!this.state.CountryKey}
                        value={this.state.DesignStandard || ""}
                        onChange={(e) => {
                          this.props.forceRevalidation();
                          this.handleChange(e);
                        }}
                        size={this.standards && (this.standards.length + 1)}
                      >
                        {this.state.CountryKey && this.state.CountryKey.length
                          ? <option value="" disabled>{APP_TEXTS.OPTIONS_SELECT_STANDARD.Content}</option>
                          : <option value="" disabled>{APP_TEXTS.OPTIONS_SELECT_COUNTRY_FIRST.Content}</option>
                        }

                        {this.standards && this.standards.length && this.standards.map(n => (
                          <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
                        ))}
                      </select>
                    </div>
                  </Tooltip>

                  <Tooltip content={APP_TOOLTIPS.LANGUAGE.Content}>
                    <div className="d-flex GeneralSettings__select-holder type_2">
                      <span>{APP_TEXTS.LANGUAGE.Content}</span>
                      <select className="form-control GeneralSettings__select"
                        name="LanguageKey"
                        value={this.state.LanguageKey || ""}
                        onChange={this.handleChangeLanguage}
                      >
                        {this.state.languages && this.state.languages.length && this.state.languages.map(n => (
                          <option value={Number(n['InternalName'])} key={Number(n['InternalName'])}>
                            {n['RunName']}
                          </option>
                        ))}
                        {/* {Number(this.state.CountryKey) === countryList['Canada'] ? 
                      (
                        <React.Fragment>
                          <option key={'English US'} value={languageList['English US']}>{'English US'}</option>
                          <option key={'French, Canadian'} value={languageList['French, Canadian']}>{'French, Canadian'}</option>
                        </React.Fragment>
                      ) : (Number(this.state.CountryKey) === countryList['North America'] ? (
                        <option key={'English US'} value={languageList['English US']}>{'English US'}</option>
                      ) : (BRAND === brandList.Ramset ? 
                      (
                        <option key={'English'} value={languageList['English']}>{'English'}</option>
                      ) :
                        Object.keys(languageList).map(lang => (
                        <option key={lang} value={languageList[lang]}>{lang}</option>
                        ))
                      ))} */}
                      </select>
                    </div>
                  </Tooltip>
                </section>
              </div>
            </AccordionItem>

            <AccordionItem id="user-profile-options" title={APP_TEXTS.MENU_OPTIONS_USER_PROFILE.Content}>
              <form 
                className="list-type" 
                id="user-profile-form" 
                ref={(ref) => this.formRef = ref} 
                onSubmit={(e) => {
                  e.preventDefault();
                  this.submitUserProfileData(e);
                }}
              >
               <Tooltip content={APP_TOOLTIPS.TOOLTIP_COMPANY_NAME.Content}>
                <Input
                  className="d-flex justify-content-between align-items-center GeneralSettings__select-holder mt-2"
                  id="company_name"
                  prefix={APP_TEXTS.OPTIONS_PROFILE_COMPANY_NAME.Content}
                  value={this.state.userProfile.companyName}
                  onUpdate={(e) => { this.updateUserProfile({ companyName: e }); }}
                />
                </Tooltip>

                <Tooltip content={APP_TOOLTIPS.TOOLTIP_USER_NAME.Content}>
                <Input
                  className="d-flex justify-content-between align-items-center GeneralSettings__select-holder mt-2"
                  id="user_name"
                  prefix={APP_TEXTS.OPTIONS_PROFILE_USER_NAME.Content}
                  value={this.state.userProfile.userName}
                  onUpdate={(e) => { this.updateUserProfile({ userName: e }); }}
                />
                </Tooltip>

                {/* <Tooltip content={APP_TOOLTIPS.TOOLTIP_INPUT_ADDRESS.Content}>
                <Input
                  className="d-flex justify-content-between align-items-center GeneralSettings__select-holder mt-2"
                  id="address"
                  prefix={APP_TEXTS.OPTIONS_PROFILE_ADDRESS.Content}
                  value={this.state.userProfile.address}
                  onUpdate={(e) => { this.updateUserProfile({ address: e }); }}
                />
                </Tooltip> */}

                <Tooltip content={APP_TOOLTIPS.TOOLTIP_PHONE_NUMBER.Content}>
                <Input
                  className="d-flex justify-content-between align-items-center GeneralSettings__select-holder mt-2"
                  id="phone_number"
                  prefix={APP_TEXTS.OPTIONS_PROFILE_PHONE_NUMBER.Content}
                  value={this.state.userProfile.phoneNumber}
                  onUpdate={(e) => { this.updateUserProfile({ phoneNumber: e }); }}
                />
                </Tooltip>

                <Tooltip content={APP_TOOLTIPS.TOOLTIP_EMAIL_ADDRESS.Content}>
                <Input
                  className="d-flex justify-content-between align-items-center GeneralSettings__select-holder mt-2"
                  id="email_address"
                  prefix={APP_TEXTS.OPTIONS_PROFILE_EMAIL_ADDRESS.Content}
                  value={this.state.userProfile.emailAddress}
                  onUpdate={(e) => { this.updateUserProfile({ emailAddress: e }); }}
                />
                </Tooltip>
                
                <Tooltip content={APP_TOOLTIPS.TOOLTIP_WEBSITE_ADDRESS.Content}>
                <Input
                  className="d-flex justify-content-between align-items-center GeneralSettings__select-holder mt-2"
                  id="website_address"
                  prefix={APP_TEXTS.OPTIONS_PROFILE_WEBSITE_ADDRESS.Content}
                  value={this.state.userProfile.websiteAddress}
                  onUpdate={(e) => { this.updateUserProfile({ websiteAddress: e }); }}
                />
                </Tooltip>
              </form>
            </AccordionItem>

            <AccordionItem id="environment-options" title={APP_TEXTS.MENU_OPTIONS_ENVIRONMENT.Content}>
              <section className="list-type">
                <Tooltip content={APP_TOOLTIPS.PROFILE_TYPES.Content}>
                  <div className="d-flex justify-content-between align-items-center GeneralSettings__select-holder mt-2 base-plate">
                    <span>{APP_TEXTS.PROFILE_TYPES.Content}</span>
                    <select className={this.state.AvailableProfileTypes && this.state.AvailableProfileTypes.length ?
                       this.cssSelected : this.cssEmpty}
                      name="AvailableProfileTypes"
                      disabled={!this.state.CountryKey}
                      value={this.state.AvailableProfileTypes}
                      onChange={this.handleChange}
                    >
                      {this.state.CountryKey && this.state.CountryKey.length
                        ? <option value="" disabled>{APP_TEXTS.OPTIONS_SELECT_PROFILE_TYPE.Content}</option>
                        : <option value="" disabled>{APP_TEXTS.OPTIONS_SELECT_COUNTRY_FIRST.Content}</option>
                      }

                      {this.profiles && this.profiles.length && this.profiles.map(n => (
                        <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
                      ))}
                    </select>
                  </div>
                </Tooltip>
                <Input
                  className="d-flex justify-content-between align-items-center GeneralSettings__select-holder mt-2 base-plate"
                  id="project_name"
                  prefix={APP_TEXTS.PROJECT_NAME.Content}
                  value={this.state.projectName}
                  onUpdate={(e) => { 
                    this.props.forceRevalidation();
                    this.setState({ projectName: e });
                  }}
                />
                {/* <div className="d-flex justify-content-between align-items-center GeneralSettings__select-holder mt-3">
                  <span>{APP_TEXTS.EXTEND_TIMEOUT.Content}</span>
                  <input
                    id="extend_timeout"
                    type="checkbox"
                    checked={this.state.extendTimeout}
                    onChange={(e) => {
                      this.props.forceRevalidation();
                      this.setState({ extendTimeout: e.target.checked });
                    }}
                  />
                </div> */}
              </section>
            </AccordionItem>

            <AccordionItem id="unit-options" title={APP_TEXTS.MENU_OPTIONS_UNITS.Content}>
              <section className="list-type">
                <UnitsForm />
              </section>
            </AccordionItem>
          </Accordion>

          <div className="d-flex align-items-center mt-3 mb-2 pl-2">
            <button className="GeneralSettings__button" type="submit" form="user-profile-form" onClick={this.initializeApp}>
              {APP_TEXTS.BUTTONS_START.Content}
            </button>

            {this.state.isInitSuccessShown &&
              <span className="ml-4 GeneralSettings__success">{APP_TEXTS.INITIALIZATION_HAS_SUCCEED.Content}</span>
            }
          </div>
        </Col>
      </Row>
    );
  }

  getCountries() {
    initService.getCountries().then(c => {
      if (c && c.length) {
        this.countries = c;

        // VladP: the country should be changed to default only when the user enters on the website;
        // Navigating to editor will destroy this instance. 
        // After closing the editor, the constructor will be called again and that will modify the current country/language!
        if (this.props.appStatus === APP_STATES.NOT_INITIALIZED) {
          if (this.state.CountryKey !== '' && 
            this.countries.find((country) => Number(country.InternalName) === Number(this.state.CountryKey))) {
            this.handleCountry({
              target: {
                  name: 'CountryKey',
                  value: this.state.CountryKey.toString()
              }
            });
            // this.getLanguages(this.state.CountryKey);
          } else {
            this.setState({ CountryKey: "" });
            this.getLanguages(this.countries[0].InternalName);
          }
        }
      }

      this.unsetPending();
    }, this.unsetPending);
  }


  fetchOptions(countryCode) {
    this.setState({ isPending: true });

    Promise.all([
      initService.getStandards(countryCode),
      initService.getProfiles(countryCode)
    ])
      .then(this.handleResponse)
      .then(
        this.unsetPending,
        this.unsetPending
      );
  }

  handleResponse = ([standards, profiles]) => {
    let standard = '';
    let availableProfiles = '';
    if (standards && standards.length || profiles && profiles.length) {
      if (BRAND === brandList.Ramset && parseInt(this.state.CountryKey) === countryList['Australia']) {
        if (standards.find((std) => { return Number(std.InternalName) === standardList['AS5216']; }))
          standard = standardList['AS5216'].toString();
        if (profiles.find((profiles) => { return profiles.InternalName === '2'; }))
          availableProfiles = '2';
        this.setState({ DesignStandard: standard, AvailableProfileTypes: availableProfiles });
      }
      else if (BRAND === brandList.Ramset && parseInt(this.state.CountryKey) === countryList['New Zealand']) {
        if (standards.find((std) => { return Number(std.InternalName) === standardList['EU']; }))
          standard = standardList['EU'].toString();
        if (profiles && profiles.length && profiles.find((profiles) => { return profiles.InternalName === '2'; }))
          availableProfiles = '2';
        this.setState({ DesignStandard: standard, AvailableProfileTypes: availableProfiles });
      }
      else if (BRAND === brandList.Sea && 
        (parseInt(this.state.CountryKey) === countryList['South East Asia'] || 
        parseInt(this.state.CountryKey) === countryList['Hong Kong'])) {
        if (standards.find((std) => { return Number(std.InternalName) === standardList['EU']; }))
          standard = standardList['EU'].toString();
        if (profiles.find((profiles) => { return profiles.InternalName === '0'; }))
          availableProfiles = '0';
        this.setState({ DesignStandard: standard, AvailableProfileTypes: availableProfiles });
      }
      else if (BRAND === brandList.Spit) {
        if (standards.find((std) => { return Number(std.InternalName) === standardList['EU']; }))
          standard = standardList['EU'].toString();
        if (profiles.find((profiles) => { return profiles.InternalName === '0'; }))
          availableProfiles = '0';
        this.setState({ DesignStandard: standard, AvailableProfileTypes: availableProfiles });
      }
      else if (BRAND === brandList.Redhead) {
        if (profiles.find((profiles) => { return profiles.InternalName === '1'; }))
          availableProfiles = '1';
        this.setState({ DesignStandard: standard, AvailableProfileTypes: availableProfiles });
      }
      else {
        this.setState({ DesignStandard: '', AvailableProfileTypes: '' });
      }
    }
    else {
      this.setState({ DesignStandard: '', AvailableProfileTypes: '' });
    }
    this.standards = standards;
    this.profiles = profiles;
    // this.props.setLocalization({
    //   country: this.state.CountryKey,
    //   designStandard: '',
    //   language: this.state.LanguageKey,
    //   profileType: ''
    // });
  };

  initializeApp = (e) => {
    const { CountryKey, DesignStandard, LanguageKey, AvailableProfileTypes, Brand } = this.state;
    // Chrome sends the autofilled value only on form submit due to security issues
    // the OK button acts now as submit button for the userprofile form (only when the User Profile Accordion is active)
    // instead of adding onChange event for all inputs, get the real value here (might differ to the state due to the autofill)
    let userProfile;
    if (e.target.form) { 
      userProfile = {
        companyName: e.target.form.company_name.value,
        userName: e.target.form.user_name.value,
        phoneNumber: e.target.form.phone_number.value,
        emailAddress: e.target.form.email_address.value,
        websiteAddress: e.target.form.website_address.value
      };
      this.setState({ userProfile });
    } else {
      userProfile = this.state.userProfile;
    }

    if (!CountryKey.length || !DesignStandard.length || !AvailableProfileTypes.length) {
      callInfoNotification(APP_TEXTS.NOTIFICATIONS_SPECIFY_OPTIONS.Content);

      return;
    }

    this.setState({ isPending: true });

    initService.initializeWith({
      CountryKey,
      DesignStandard,
      LanguageKey,
      AvailableProfileTypes,
      Brand,
      userProfile
    })
      .then(
        this.handleSuccess(CountryKey, DesignStandard, LanguageKey, AvailableProfileTypes, userProfile),
        this.unsetPending
      );

  };

  handleSuccess = async (CountryKey, DesignStandard, LanguageKey, AvailableProfileTypes, userProfile) => {
    await loadTranslations();
    await loadTooltipss();

    this.unsetPending();

    this.props.setAppStatus(APP_STATES.INITIALIZED);
    this.props.setLocalization({
      country: CountryKey,
      designStandard: DesignStandard,
      language: LanguageKey,
      profileType: AvailableProfileTypes
    });
    this.props.setUserProfile(userProfile);
    this.props.setProjectName(this.state.projectName);
    // this.props.setExtendTimeout(this.state.extendTimeout);
    this.props.show3DDimensions();
    // callSuccessNotification("Initialization has succeeded!");
    // callSuccessNotification(APP_TEXTS.INITIALIZATION_HAS_SUCCEED.Content);
    this.props.setActiveTab(TABS.APPLICATION);
  };

  handleCountry = (e) => {
    // if ((Number(e.target.value) === countryList['Canada'] &&
    //  (this.state.LanguageKey !== languageList['French, Canadian'] || this.state.LanguageKey !== languageList['English US'])) || 
    //  Number(e.target.value) === countryList['North America'] && this.state.LanguageKey !== languageList['English US'])
    // {
    //   this.handleChangeLanguage({ 
    //     target: {
    //       name: 'LanguageKey',
    //       value: languageList['English US']
    //     }
    //   });
    // }
    this.props.setCountryUnits(e.target.value);
    this.getLanguages(e.target.value);
    this.handleChange(e);
    this.fetchOptions(e.target.value);
  };

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  handleChangeLanguage = (e) => {
    this.handleChange(e);
    this.setState({ isPending: true });
      initService.switchLanguage(e.target.value).then(() => { // Wait for the language to switch before getting translations
   Promise.all([
      initService.getStandards(this.state.CountryKey || 0),
      initService.getProfiles(this.state.CountryKey || 0),
      initService.getCountries(),
      loadTranslations(),
      loadTooltipss()
    ])
      .then(([standards, profiles, countries]) => { 
        this.standards = standards;
        this.profiles = profiles;
        this.countries = countries;
      })
      .then(this.props.action)
      .then(() => {
        initService.getLanguages(this.state.CountryKey || 0)
          .then(res => this.setState({ languages: res }));
      })
      .then(this.unsetPending,
        this.unsetPending);
      });


    // this.props.setLanguage(e.target.value);
  };

  unsetPending = () => this.setState({ isPending: false });

  updateUserProfile(field) {
    this.props.forceRevalidation();
    this.setState({ userProfile: mergeDeep({}, this.state.userProfile, field) });
  }

  getLanguages(selectedCountry) {
    initService.getLanguages(selectedCountry).then(res => {
      if (res && res.length) {
        var key = this.state.LanguageKey;
        if (!res.filter((language) => Number(language.InternalName) === Number(key)).length) {
          this.handleChangeLanguage({
            target: {
              name: 'LanguageKey',
              value: Number(res[0].InternalName)
            }
          });
        } else {
          //VladP: Make sure the language is correctly set for the first time
          if (!this.state.languages.length) {
            this.handleChangeLanguage({
              target: {
                name: 'LanguageKey',
                value: Number(this.state.LanguageKey)
              }
            });
          } else {
            this.setState({ languages: res, LanguageKey: key });
          }
        }
      }
    });
  }

  handleAccordionClick(id, isActive) {
    // submit form only if the accordion will change from user profile opened to any other state
    if (this.formRef && (id !== "user-profile-options" || isActive)) {
      // this.formRef.submit(); // won't call our onSubmit and will trigger a refresh
      this.formRef.dispatchEvent(
        new Event("submit", { bubbles: true, cancelable: true })
      );
    }
    return true;
  }

  submitUserProfileData(e) {
    let userProfile = {
      companyName: e.target && e.target.company_name.value,
      userName: e.target && e.target.user_name.value,
      phoneNumber: e.target && e.target.phone_number.value,
      emailAddress: e.target && e.target.email_address.value,
      websiteAddress: e.target && e.target.website_address.value
    };

    this.setState({ userProfile });
  }

};



// WEBPACK FOOTER //
// ./src/views/Options/Options.js